import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actions } from '../Reducks/User/index';
import AnalyticsDashboard from '../GoToWebinar/Dashboard/AnalyticsDashboard';
import AdminAnalyticsDashboard from '../GoToWebinar/Admin/AdminDashboard/AnalyticsDashboard';
import FullScreenLoadingComponent from '../Components/Loaders/FullScreenLoadingComponent';
import { setAnonymousId } from '../Model/UserProperties';
import { translate } from 'react-i18next';
import { RobotMessageComponent } from '../Components/RobotMessageComponent/RobotMessageComponent';
import { RobotMessageState } from '../Utils/Constants';

class G2WAnalyticsApp extends Component {
  static propTypes = {
    reduced_user: PropTypes.object,
    getLoggedInUser: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    const {
      match: { params }
    } = this.props;
    setAnonymousId();
    this.props.getLoggedInUser(props.isAdmin, params.accountKey);
  }
  render() {
    return this.getComponentBasedOnAppReadyStatus();
  }

  getComponentBasedOnAppReadyStatus() {
    let { appReady, error, isSettingsFetched, user } = this.props.reduced_user;

    if (error && error.response && (error.response.status >= 500 || error.response.status === 400)) {
      return <RobotMessageComponent type={RobotMessageState.ERROR_STATE} />;
    }

    if (appReady !== true || !isSettingsFetched) {
      return <FullScreenLoadingComponent />;
    }

    if (user.accountKey && user.isAdmin) {
      return <AdminAnalyticsDashboard />;
    }

    return <AnalyticsDashboard />;
  }
}

export default connect(
  state => ({ reduced_user: state.reduced_user }),
  { getLoggedInUser: actions.getLoggedInUser }
)(translate(['translation'])(G2WAnalyticsApp));



// WEBPACK FOOTER //
// ./src/Application/G2WAnalyticsApp.js